// collection of our endpoints
// look at making this fancier later
// there is construct(() stuff we could use

// admin
const GET_USERS = "/api/admin/users";
const GET_ROLES = "/api/admin/roles";
const ADD_NEW_USER = "/api/admin/user/create";
const DELETE_USER = "/api/admin/user/delete";
const UPDATE_USER = "/api/admin/user/update";

const ADD_NEW_SKILL = "/api/admin/skill/add";
const UPDATE_SKILL = "/api/admin/skill/update";
const DELETE_SKILL = "/api/admin/skill/delete";

const MERGE_SKILLS = "/api/admin/skill/merge";

const ADD_NEW_SKILL_TYPE = "/api/admin/skill/type/add";
const UPDATE_SKILL_TYPE = "/api/admin/skill/type/update";
const DELETE_SKILL_TYPE = "/api/admin/skill/type/delete";

const ADD_NEW_CERT = "/api/admin/cert/add";
const UPDATE_CERT = "/api/admin/cert/update";
const DELETE_CERT = "/api/admin/cert/delete";

const MERGE_CERTS = "/api/admin/cert/merge";


// user info
const GET_CLEARANCES = "/api/clearances";
const GET_ME = "/api/users/me";
const GET_PDF = "/api/pdf/"; // /{email}
const GET_USER_INFO = "/api/user/email/";
const GET_OR_CREATE_USER = "/api/user/create";
const UPDATE_USER_INFO = "/api/user/update"
const UPDATE_USER_ACK = "/api/user/ack";

// skills
const GET_SKILLS = "/api/skill/skills";
const GET_SKILL_TYPES = "/api/skill/types";
const GET_EXP_LVLS = "/api/skill/explvl";
const GET_USER_SKILLS = "/api/user/{id}/skills";
const UPDATE_USER_SKILL = "/api/user/skill/update";
const ADD_NEW_USER_SKILL  = "/api/user/skill/add";
const DELETE_USER_SKILL = "/api/user/skill/delete";

//certs
const GET_CERTS = "/api/cert/certs";
const GET_USER_CERTS = "/api/user/{id}/certs";
const UPDATE_USER_CERT = "/api/user/cert/update";
const ADD_NEW_USER_CERT  = "/api/user/cert/add";
const DELETE_USER_CERT = "/api/user/cert/delete";

// education
const GET_DEGREES = "/api/degree/degrees";
const GET_USER_DEGREES = "/api/user/{id}/degrees";
const UPDATE_USER_DEGREE = "/api/user/degree/update";
const ADD_NEW_USER_DEGREE  = "/api/user/degree/add";
const DELETE_USER_DEGREE = "/api/user/degree/delete";

// exp
const GET_USER_EXPERIENCE= "/api/user/{id}/experience";
const UPDATE_USER_EXPERIENCE = "/api/user/experience/update";
const ADD_NEW_USER_EXPERIENCE  = "/api/user/experience/add";
const DELETE_USER_EXPERIENCE = "/api/user/experience/delete";

// projects
const GET_USER_PROJECTS= "/api/user/{id}/projects";
const UPDATE_USER_PROJECT = "/api/user/project/update";
const ADD_NEW_USER_PROJECT  = "/api/user/project/add";
const DELETE_USER_PROJECT = "/api/user/project/delete";

// preview

const GET_USER_PREVIEW = "/api/user/{id}/preview";

// reporting

const BASIC_QUERY = "/api/query/basic";
const EXTERNAL_API_QUERY = "/api/query/external";
const GET_ALL_EDUCATION = "/api/query/education"
const GET_ALL_EXPERIENCE = "/api/query/experience"

// dashboard

const USER_DASHBOARD = "/api/user/{id}/dashboard";
const ADMIN_DASHBOARD = "/api/admin/dashboard";

export {
    GET_USERS,
    GET_ROLES,
    ADD_NEW_USER,
    DELETE_USER,
    UPDATE_USER,
    ADD_NEW_SKILL,
    UPDATE_SKILL,
    DELETE_SKILL,
    MERGE_SKILLS,
    ADD_NEW_SKILL_TYPE,
    UPDATE_SKILL_TYPE,
    DELETE_SKILL_TYPE,
    ADD_NEW_CERT,
    UPDATE_CERT,
    DELETE_CERT,
    MERGE_CERTS,
    GET_CLEARANCES,
    GET_ME,
    GET_PDF,
    GET_USER_INFO,
    GET_OR_CREATE_USER,
    UPDATE_USER_INFO,
    UPDATE_USER_ACK,
    GET_SKILLS,
    GET_SKILL_TYPES,
    GET_EXP_LVLS,
    GET_USER_SKILLS,
    UPDATE_USER_SKILL,
    ADD_NEW_USER_SKILL,
    DELETE_USER_SKILL,
    GET_CERTS,
    GET_USER_CERTS,
    UPDATE_USER_CERT,
    ADD_NEW_USER_CERT,
    DELETE_USER_CERT,
    GET_DEGREES,
    GET_USER_DEGREES,
    ADD_NEW_USER_DEGREE,
    UPDATE_USER_DEGREE,
    DELETE_USER_DEGREE,
    GET_USER_EXPERIENCE,
    UPDATE_USER_EXPERIENCE,
    ADD_NEW_USER_EXPERIENCE,
    DELETE_USER_EXPERIENCE,
    GET_USER_PROJECTS,
    UPDATE_USER_PROJECT,
    ADD_NEW_USER_PROJECT,
    DELETE_USER_PROJECT,
    GET_USER_PREVIEW,
    BASIC_QUERY,
    EXTERNAL_API_QUERY,
    GET_ALL_EDUCATION,
    GET_ALL_EXPERIENCE,
    USER_DASHBOARD,
    ADMIN_DASHBOARD,
};